import React from 'react';

import { Calendar2Outline, TimerOutline } from '@lyearn/icons';
import { Stack, StatusPill, Typography } from '@lyearn/ui';
import { getOverdue } from '@/modules/content/components/ContentCard/utils/getOverdue';
import { ContentOverdueDueEnum } from '@/modules/content/components/ContentCard/utils/types';

interface DueOnProps {
  overdue: ReturnType<typeof getOverdue>;
  showIcon?: boolean;
}

const DueOn = ({ overdue, showIcon = false }: DueOnProps) => {
  if (!overdue) {
    return null;
  }

  const statusPillLabel = showIcon ? overdue?.shortenedLabel : overdue?.label;
  const isNotOverdue = overdue?.status === ContentOverdueDueEnum.Due;
  const statusPillAppearance = isNotOverdue ? 'cyan' : 'danger';

  if (overdue?.status === ContentOverdueDueEnum.Completed) {
    return null;
  }

  const Icon = showIcon ? (
    isNotOverdue ? (
      <Calendar2Outline className="h-16 w-16" fillColorToken="icon-accent" />
    ) : (
      <TimerOutline className="h-16 w-16" fillColorToken="icon-error" />
    )
  ) : null;

  return (
    <StatusPill
      appearance={statusPillAppearance}
      label={
        <Stack alignItems="center" gapX={6}>
          {Icon}
          {statusPillLabel ? (
            <Typography
              className={isNotOverdue ? 'text-text-accent' : 'text-text-error'}
              variant="body-short-02">
              {statusPillLabel}
            </Typography>
          ) : null}
        </Stack>
      }
      variant="light"
    />
  );
};

export default React.memo(DueOn);
